// extracted by mini-css-extract-plugin
module.exports = {"root":"IntervalStatusContainer_root__2N6B9","bordered":"IntervalStatusContainer_bordered__2g6JF"};